
<template>
  <div class="abnormal">
    <div class="filter-container flex">
      <div class="filter-box">
        <div class="filter-item mr-sm">
          <f-radio-btn-group v-model="query.status" :groups="status" @change="fetchStat()"/>
        </div>
        <div class="filter-item mr-sm" style="width: 160px">
          <f-dev-selector v-model="query.devid" :show-not-load="true" placeholder="选择模型" width="160" @change="fetchStat()"/>
        </div>
        <span class="filter-item">
          <el-input v-model="query.keyword" placeholder="接入点编号/GO" prefix-icon="el-icon-search" clearable @change="fetchStat()" style="width: 160px"/>
        </span>
      </div>
      <div class="toolbox">
        <f-sort-selector v-model="query.sortby" :options="sortOptions" width="80" class="ml-sm" @change="fetchStat()"/>
      </div>
    </div>
    <el-card class="mb-md" shadow="never">
      <el-row :gutter="20">
        <el-col v-for="(item,index) in statList" :key="index" :span="24/statList.length">
          <div class="bg-light radius5" @click="select(item.code)" :class="query.type == item.code && 'active'">
            <div class="pt pl pb pr flex justify-content-space-between align-items-center">
              <div class="flex align-items-center">
                <div style="font-size: 20px">
                  <span class="iconfont icon-circle-warning text-danger mr"></span>
                </div>
                <span>{{ item.name }}</span>
              </div>
              <div style="font-size: 20px">{{ item.count }}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card v-loading="loading" shadow="never">
      <div class="flex align-items-center mb">
        <el-tag
          v-for="tag_item in tags"
          :key="tag_item.reason_code"
          @click="tagSelect(tag_item.reason_code)"
          :type="query.reason_code == tag_item.reason_code ? 'danger' : 'info'"
          class="mr-sm custom-tag"
          size="small"
        >
          {{ tag_item.name }}<span class="ml-xs mr-xs text-bold font-md">·</span>{{ tag_item.count }}
        </el-tag>
      </div>
      <el-table ref="listTable" :data="list" tooltip-effect="dark">
        <el-table-column width="60" type="index" label="#" />
        <el-table-column label="接入点编号" :show-overflow-tooltip="true" min-width="120">
          <template slot-scope="scope">
            <el-link :underline="false" @click="toApDialog(scope.row)">{{ scope.row.simid }}</el-link>
          </template>
        </el-table-column>

        <el-table-column label="设备" min-width="120">
          <template slot-scope="scope">
            <f-equip-name class="font-md" :equip="{equipid: scope.row.equipid, equip_name: scope.row.sim_go}" />
          </template>
        </el-table-column>

        <el-table-column label="状态/通讯时间" min-width="120">
          <template slot-scope="scope">
            <div class="flex align-items-center">
              <div class="hd mr-sm font-lg">
                <i v-if="scope.row.is_online === 1" class="iconfont icon-circle-outline text-success"></i>
                <i v-else class="text-muted iconfont icon-circle-fill" />
              </div>
              <div class="bd" style="line-height: 16px">
                <div>{{ scope.row.is_online ? '在线' : '离线' }}</div>
                <div class="font-sm text-muted">{{ scope.row.last_upload_time | parseTime('{y}/{m}/{d} {h}:{i}') }}</div>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="类型" :show-overflow-tooltip="true" min-width="100">
          <template slot-scope="scope">
            <el-tag :type="'danger'" class="mr-sm" size="small">{{ reasonCodeObj[scope.row.reason_code] }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="异常开始时间" min-width="130">
          <template slot-scope="scope">{{ scope.row.starttime | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</template>
        </el-table-column>
        <el-table-column label="异常描述" prop="description" :show-overflow-tooltip="true" min-width="200" />

        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="handleDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
        <div slot="empty" class="flex-center column pb-md">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt class="no-data" />
          </div>
        </div>
      </el-table>
    </el-card>
    <div class="foot" :class="!collapse && 'uncollapse'">
      <f-table-footer>
        <template slot="right">
          <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
        </template>
      </f-table-footer>
    </div>

    <abnormal-detail v-if="showDetail" :show.sync="showDetail" :id="activeId" />
  </div>
</template>

<script>
import { apDtusimStatApi, apAbnormalApi } from "@/api/ap/apApi";

export default {
  components: {
    AbnormalDetail: () => import("./components/AbnormalDetail.vue"),
  },
  data() {
    return {
      loading: false,
      status: [
        { value: -1, title: "全部", separate: true },
        { value: 1, title: "在线" },
        { value: 2, title: "离线" },
      ],
      sortOptions: [
        { value: 0, title: "最近异常" },
        { value: 1, title: "最近激活" },
        { value: 2, title: "最近创建" },
      ],

      query: {
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
        keyword: "",
        type: "",
        reason_code: "",
        status: -1,
        devid: null,
        sortby: 0,
      },
      list: [],
      statList: [],
      total: 0,

      tags: [],
      showDetail: false,
      activeId: "",
    };
  },
  computed: {
    collapse() {
      return this.$store.state.commonStore.collapse;
    },

    reasonCodeObj() {
      return this.$store.getters.reasonCodeObj;
    },
  },
  created() {
    this.fetchStat(1);
  },
  methods: {
    fetchData(page) {
      if (page) this.query.pindex = page;
      this.loading = true;
      apAbnormalApi(this.query).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.list = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    fetchStat() {
      this.loading = true;
      apDtusimStatApi({
        keyword: this.query.keyword,
        status: this.query.status,
        devid: this.query.devid,
        type: this.query.type,
      }).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.statList = res.data.abnormals;
          this.tags = res.data.reason_codes.map((item) => {
            item.name = this.reasonCodeObj[item.reason_code]
              ? this.reasonCodeObj[item.reason_code]
              : item.reason_code;
            return item;
          });

          this.fetchData(1);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleDetail(row) {
      this.showDetail = true;
      this.activeId = row.id;
    },
    select(code) {
      if (code === this.query.type) {
        this.query.type = "";
      } else {
        this.query.type = code;
      }
      this.query.reason_code = "";
      this.fetchStat();
    },
    tagSelect(code) {
      if (code === this.query.reason_code) {
        this.query.reason_code = "";
      } else {
        this.query.reason_code = code;
      }
      this.fetchStat();
    },
    view(equipid) {
      this.$detail({ type: "equip", id: equipid });
    },
    toApDialog(row) {
      this.$detail({ type: "ap", id: row.simid });
    },
  },
};
</script>

<style lang="scss" scoped>
.abnormal {
  margin-bottom: 70px;
  .bg-light:hover {
    cursor: pointer;
  }
  .active {
    background-color: #fdecec;
  }
  .custom-tag {
    cursor: pointer;
    user-select: none;
  }
}
.foot {
  position: fixed;
  background-color: #fff;
  bottom: 0;
  left: 240px;
  width: calc(100% - 240px);

  &.uncollapse {
    left: 340px;
    width: calc(100% - 340px);
  }
}
</style>
